import Cookies from 'js-cookie'
// 保存用户数据key
export const TOKEN_KEY = 'token'
// 设置token
export const setToken = (token) => {
    Cookies.set(TOKEN_KEY, token)
}
// 读取token
export const getToken = () => {
    const token = Cookies.get(TOKEN_KEY)
    if (token) return token
    else return false
}
// 设置用户数据
export const setAdmin = (key, data) => {
    Cookies.set(key, data)
}
// 读取用户数据
export const getAdmin = (key) => {
    const data = Cookies.get(key)
    // console.log(key + "____" +data)
    if (data) return data
    else return false
}




// WEBPACK FOOTER //
// ./src/assets/js/util.js